import { Controller } from "@hotwired/stimulus"

// Purchase panel form: delivery category sections and submit enablement.
export default class extends Controller {
  static targets = [
    "category",
    "contract",
    "submit",
    "chargeSection",
    "depositSection",
    "printDeliverySection",
  ]

  connect() {
    this.chargeEnabled = false
    this.updateSections()
    this.updateSubmitButton()
  }

  categoryChanged() {
    this.updateSections()
    this.updateSubmitButton()
  }

  selectionChanged() {
    this.updateSubmitButton()
  }

  updateSections() {
    const digitalCharge = this.categoryChecked("digital_category_charge")
    const printCharge = this.categoryChecked("print_category_charge")
    const printDeposit = this.categoryChecked("print_category_deposit")
    const showCharge = digitalCharge || printCharge

    if (this.hasChargeSectionTarget) {
      this.chargeSectionTarget.classList.toggle("hidden", !showCharge)
    }

    if (this.hasDepositSectionTarget) {
      this.depositSectionTarget.classList.toggle("hidden", !printDeposit)
    }

    if (this.hasPrintDeliverySectionTarget) {
      const showPrintDelivery = printCharge || printDeposit
      this.printDeliverySectionTarget.classList.toggle("hidden", !showPrintDelivery)
    }

    if (showCharge !== this.chargeEnabled) {
      this.chargeEnabled = showCharge
      this.dispatch("chargeToggled", { detail: { charge: showCharge } })
    }
  }

  updateSubmitButton() {
    if (!this.hasSubmitTarget) return

    const hasCategory = this.categoryTargets.some((element) => element.checked)
    const hasContract = this.contractTargets.some((element) => element.checked)
    const enabled = hasCategory && hasContract

    this.submitTarget.disabled = !enabled
    this.submitTarget.classList.toggle("opacity-50", !enabled)
    this.submitTarget.classList.toggle("pointer-events-none", !enabled)
    this.submitTarget.classList.toggle("text-select-none", !enabled)
  }

  categoryChecked(value) {
    return this.categoryTargets.some(
      (element) => element.checked && element.value === value
    )
  }
}
